import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CustomButton from "./CustomButton";
import TranslatedMessage from "../../translations/TranslatedMessage";
import { TranslationKey } from "../../../translations/TranslationKey";


export interface ButtonMenuItem {
  key: string;
  label: string;
}

interface ButtonMenuProps {
  tooltip: string;
  label?: string;
  icon?: React.ReactNode;
  items: ButtonMenuItem[];
  onSelect: (key: string) => void;
}

const ButtonMenu: React.FC<ButtonMenuProps> = ({ tooltip, items, onSelect, label, icon }) => {
  const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(null);
  const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, key: string) => {
    onSelect(key);
    setAnchorElement(null);
  };

  return (
    <>
     <CustomButton
        color="primary"
        tooltip={<TranslatedMessage id={tooltip as TranslationKey} />}
        onClick={(e) => setAnchorElement(e.currentTarget)}
      >
        {label ? <TranslatedMessage id={label as TranslationKey} /> : null}
        {icon}
      </CustomButton>
      <Menu
        anchorEl={anchorElement}
         getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        keepMounted
        open={Boolean(anchorElement)}
        onClose={() => setAnchorElement(null)}
      >
        {items.map(item => (
          <MenuItem key={item.key} onClick={(event) => handleMenuItemClick(event, item.key)}>
            <TranslatedMessage id={item.label as TranslationKey} />
          </MenuItem>
        ))}
      </Menu>
      </>
  );
};

export default ButtonMenu;
